import {Locale, LOCALE_FORMAT} from "../locale"


export enum InputMode { DATE, YEAR}

export class DateOrYear {
    static formatter = new Intl.DateTimeFormat(LOCALE_FORMAT[Locale.EN])
    mode: InputMode
    date!: Date
    year!: number

    constructor(input: { mode: InputMode.DATE; date: Date } | { mode: InputMode.YEAR; year: number }) {
        this.mode = input.mode
        if (input.mode === InputMode.DATE)
            this.date = input.date
        else
            this.year = input.year
    }

    static serialize(dateOrYear: { mode: InputMode.DATE, date: Date } | { mode: InputMode.YEAR, year: number }): string {
        if (dateOrYear.mode === InputMode.YEAR) return String(dateOrYear.year)
        return DateOrYear.formatter.format(dateOrYear.date).replace(/\//g, "-")
    }
    static deserialize(value: any): { mode: InputMode.DATE, date: Date } | { mode: InputMode.YEAR, year: number } | any {
        try {
            const trimmed = value?.trim()
            if (!trimmed) return undefined
            // Year only
            if (/^\d{4}$/.test(trimmed)) {
                return new DateOrYear({ mode: InputMode.YEAR, year: parseInt(trimmed) })
            }
            // dd-MM-yyy
            const match = trimmed.match(/^(\d{2})-(\d{2})-(\d{4})$/)
            if (match) {
                const [, dd, mm, yyyy] = match
                const date = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd))
                if (!isNaN(date.getTime())) return new DateOrYear({ mode: InputMode.DATE, date })
                return undefined
            }
            const parsedDate = new Date(trimmed)
            if (!isNaN(parsedDate.getTime())) return new DateOrYear({ mode: InputMode.DATE, date: parsedDate })
        } catch(e) {
            console.warn(`Failed to deserialize date: ${value}`)
            // These deserialization errors have to climb up all the way to the validation report
            return value
        }
    }
}